import axiosInstance from './AxiosWrapper'
import { ENDPOINT_USERS, ENDPOINT_USERS_ADMIN } from './Endpoints'

export const getAllUsers = async () => {
  return await axiosInstance.get(ENDPOINT_USERS)
}

export const getAdminUsers = async () => {
  return await axiosInstance.get(ENDPOINT_USERS_ADMIN)
}
